'use strict';

var $billingFieldsToggle = $('.toggle-billing-address');
var $billingFields = $('.billing-fields');
var $optionalBillingfields = $billingFields.find('.billing-required');

// Toggles billing form when address is not the same as billing address
$billingFieldsToggle.on('change', function (e) {
    var checked = $(this).hasClass('inverse') ? !this.checked : this.checked;

    $billingFields.attr('hidden', checked);
    $optionalBillingfields
        .attr('required', !checked)
        .prev('label')
        .toggleClass('required', !checked);
}).trigger('change');